export default __webpack_public_path__ + "static/media/bg1.c53c8971.jpg";